import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import AngleDivider from "./AngleDivider";

interface Data {
    paragraphById: {
        fieldVarTopColor: string;
        fieldVarBottomColor: string;
    }
}

class AngleDividerComponentQuery extends Query<Data, {id: string}> {}

const GET_CARDS = gql`
    query paragraphById($id: String!) {
        paragraphById:paragraphRevisionById(id: $id) {
            ... on ParagraphComponentAngledDivider {
                fieldVarTopColor
                fieldVarBottomColor
            }
        }
    }
`;

const AngleDividerComponent = ({id, markComponentLoadedAs}) => (
    <AngleDividerComponentQuery asyncMode query={GET_CARDS} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            return (<AngleDivider topColor={field.fieldVarTopColor} bottomColor={field.fieldVarBottomColor}/>);

        }}
    </AngleDividerComponentQuery>
);

AngleDividerComponent.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default AngleDividerComponent;



// WEBPACK FOOTER //
// ./frontend/components/AngleDivider/AngleDividerComponent.jsx